export const GoogleMapsAPI = 'AIzaSyCv0JT6W6tMYCww1FnEjf6CxaKUFIhbNdA';
